import app from "@/app";

import pinia from "@/stores";
import router from "@/router";

app
    .use(pinia)
    .use(router)
